/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "colors_plain": "border-white bg-white text-al-petroleum-900 hover:bg-al-petroleum-100 hover:border-al-petroleum-100 focus:bg-white focus:border-white active:bg-al-petroleum-200 active:border-al-petroleum-200",
  "colors_filled": "border-transparent bg-al-petroleum-600 text-white active:border-al-petroleum-900 active:bg-al-petroleum-900",
  "colors_border": "border-al-petroleum-600 bg-transparent text-al-petroleum-600 hover:bg-al-petroleum-100 focus:bg-transparent active:bg-al-petroleum-200",
  "size_default": "w-8 h-8",
  "variant_default": "inline-flex items-center justify-center transition-all duration-200 ease-in-out ring-0 border rounded-full focus:outline-none hover:ring-0 hover:outline-none active:ring-0 active:outline-none focus:ring-0 outline-none"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "SoMe");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;